import axios from "axios";

//can only use this for un-authed routes sessionCode/{id} and sessions{id}
const api = axios.create({
  baseURL: "https://s1chptbuta.execute-api.us-west-2.amazonaws.com",

  responseType: "json",
});

api.interceptors.request.use(
  async (config) => {
  
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
